// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul.dot-list li[data-v-cb258c98]{position:relative}ul.dot-list li[data-v-cb258c98]:before{content:\"•\";left:.2em;position:absolute}ul.dot-list__item[data-v-cb258c98]{word-wrap:break-word}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
